import { useQuery } from "react-query";
import { useGraphqlRequestConfigContext } from "../../contexts/graphqlRequestConfigContext";
import { createConversationId } from "../../graphql-utils";
import fetchQuery from "../../graphql-utils/fetch";
const generateUseGraphqlQuery = (name, version) => {
  const commonHeaders = {
    ConversationId: createConversationId(name),
    "Content-Type": "application/json",
    "x-client-name": name,
    "x-app-version": version
  };
  const useGraphqlQuery = (gqlQuery, variables, config) => {
    var _a, _b, _c;
    const { endpoint, method, headers } = useGraphqlRequestConfigContext();
    const { requestConfig, ...reactQueryOptions } = config || {};
    const requestConfigData = requestConfig ? {
      endpoint: ((_a = config == null ? void 0 : config.requestConfig) == null ? void 0 : _a.endpoint) || endpoint,
      method: ((_b = config == null ? void 0 : config.requestConfig) == null ? void 0 : _b.method) || method || "POST",
      headers: {
        ...commonHeaders,
        ...headers || {},
        ...((_c = config == null ? void 0 : config.requestConfig) == null ? void 0 : _c.headers) || {}
      }
    } : {
      endpoint,
      method: method || "POST",
      headers: {
        ...commonHeaders,
        ...headers
      }
    };
    return useQuery([gqlQuery, variables, requestConfigData], fetchQuery, reactQueryOptions);
  };
  return { useGraphqlQuery };
};
var useGraphqlQuery_default = generateUseGraphqlQuery;
export {
  useGraphqlQuery_default as default
};
